export default function getFilenameFromContentDisposition(
  contentDisposition: string
): string {
  const match = /filename[^;=\n]*="(.*?\2|[^;\n]*)"/.exec(contentDisposition);
  return match ? decodeURIComponent(match[1]) : 'filename';
}
